import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ExistingDummyRoomDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	roomID: string;
};

export const useDummyRoomEditQuery = ({ hotelID, roomID }: Props) => {
	const { data } = useCustomSuspenseQuery(ExistingDummyRoomDefault_EditPage_Query, {
		variables: { hotelID, roomId: roomID },
	});

	return data;
};
